import _import from './_import';
import routeStore from './store';
import Login from '@/containers/login/index';
import errorPage404 from '@/containers/errorPage/404';
import errorPage401 from '@/containers/errorPage/401';
import Logistics from '../containers/Dashboard/CampusCustomerData/colorfulData';

Vue.use(VueRouter);

const constantRouterMap = [
  { path: '/login', component: Login, hidden: true },
  { path: '/logistics', component: Logistics, hidden: true },
  { path: '/404', component: errorPage404, hidden: true },
  { path: '/401', component: errorPage401, hidden: true },
  // { path: '/demo', component: _import('HomePage/Demo'), hidden: true },
];

const asyncRouterMap = [{ path: '*', redirect: '/404', hidden: true }];

export { constantRouterMap, asyncRouterMap, routeStore };

export default {
  constantRouterMap,
  asyncRouterMap,
  routeStore,
};
